import React, { useState, useEffect } from 'react';
import SideNav from '../components/SideNav';
import EmployeeList from '../components/EmployeeList';
import CustomTabs from '../components/CustomTabs';
import CertificationsListCp from '../components/CertificationsListCp';
import FleetCp from '../components/FleetCp';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Users from '../components/Users';
import { useNavigate, NavLink } from 'react-router-dom';


const EmployeeListPage = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeLink, setActiveLink] = useState('employeeView');
  const [employeeCerts, setEmployeeCerts] = useState([]);
  const [fleet, setFleet] = useState([]);
  const [access, setAccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (activeLink === 'employeeView') {
      fetchEmployees();
    } else if (activeLink === 'cert') {
      fetchCertifications();
    } else if (activeLink === 'fleet') {
      fetchFleet();
    }
  }, [activeLink]);

  const fetchEmployees = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employee_crud.php?getList=1`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      });
      const data = response.data;
      if (data) {
        setEmployees(Array.isArray(data) ? data : []);
      } else {
        toast.error("Error fetching employees", {
          position: "top-center"
        });
      }
    } catch (error) {
      handleError(error);
    }
  };

  const fetchCertifications = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employee_crud.php?getCerts=true`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      });
      const data = response.data;
      if (data) {
        setEmployeeCerts(data.certs || []);
        setAccess(data.access || []);
      } else {
        toast.error("Error fetching certifications", {
          position: "top-center"
        });
      }
    } catch (error) {
      handleError(error);
    }
  };

  const fetchFleet = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employee_crud.php?getFleet=true`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      });
      const data = response.data;
      if (data) {
        setFleet(data.fleets || []);
        setAccess(data.access || []);
      } else {
        toast.error("Error fetching fleet", {
          position: "top-center"
        });
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else if (error.response && error.response.status === 403) {
      toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
        position: "top-center"
      });
    }
  };

  const handleEditCert = async (editedCert) => {
    const bodyData = {
      status: "updatingFleet",
      data: editedCert
    };
      try {
        const response = await axios.post(`${apiUrl}/employee_crud.php`, bodyData, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (response.data.success) {
           setFleet(prevFleets => {
            return prevFleets.map(fleet =>
              fleet.id === editedCert.id ? editedCert : fleet
            );
          });
          toast.success('Fleet Updated!', {
            position: 'top-center',
          });
        } else {
          toast.info("Failed to update", { position: "top-center" });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
            position: "top-center"
          });
        }
      } finally {
        setLoading(false);
      }
  };

  const onAddFleet = async(newCert) => {
  // Validate before returning early
  if (!newCert.irl_insurance) {
    toast.error("Please enter Insurance", {
      position: "top-center",
    });
    // Return false to indicate failure
    return false;
  }

    const bodyData = {
      status: "updatingFleet",
      data: newCert
    };
      try {
        const response = await axios.post(`${apiUrl}/employee_crud.php`, bodyData, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (response.data.success) {
         fetchFleet()
          toast.success('Fleet Added!', {
            position: 'top-center',
          });
        } else {
          toast.info("Failed to update", { position: "top-center" });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
            position: "top-center"
          });
        }
      } finally {
        setLoading(false);
      }
  };

  const handleDelete = async (id) => {
    // Rest of your handleDelete function
  };

  const handleFormSubmit = async (file, certId) => {
    // Rest of your handleFormSubmit function
  };  

  const handleCertFileUpload = async (file, certId) => {
    if (!file) {
      toast.error("Please upload a valid file.", { position: 'top-center' });
      return;
    }
    const formData = new FormData();
    formData.append('status', 'submit_cert_file');
    formData.append('id', certId);
    formData.append('file', file);
    try {
      const response = await axios.post(`${apiUrl}/certification_file_crud.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setEmployeeCerts((certs) =>
        certs.map((cert) => {
          if (cert.id === response.data?.certificate_file?.id) {
            return { ...cert, file_path: response.data?.certificate_file?.file_path };
          }
          return cert;
        })
      );

      if (response.data.success) {
        toast.info('Saved!', { position: 'top-center' });
      } else {
        toast.error(response.data.error, { position: 'top-center' });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center"
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: "top-center"
        });
      }
    }
  }; 

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEditCertification = async (editedCert) => {
    const bodyData = {
      data: editedCert,
      status: 'submit_cert'
    };

    try {
      const response = await axios.post(`${apiUrl}/employee_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.success) {
        toast.success("Cert successfully saved!", {
          position: "top-center"
        });
        setEmployeeCerts((prevCerts) =>
          prevCerts.map((cert) => (cert.id === editedCert.id ? editedCert : cert))
        );
      } else {
        toast.error(response.data.error || "Failed updating.", {
          position: "top-center"
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        setAccess(true);
        toast.error("Oops!! no access to edit.", {
          position: "top-center"
        });
      }
    }
  };    

  const tabs = [
    { label: 'Employees', onClick: () => setActiveLink('employeeView') },
    { label: 'Certifications', onClick: () => setActiveLink('cert') },
    { label: 'Fleet', onClick: () => setActiveLink('fleet') },
    { label: 'Users', onClick: () => setActiveLink('users') }
  ];

  return (
    <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-[200px_minmax(540px,_1fr)] gap-x-4">
      <div className="hidden md:block">
        <div className='pt-6 pr-3'>
          <SideNav />
        </div>
      </div>

      <div className="p-4">
        <div className="relative mb-6">
          <h1>All Staff</h1>
          <br />

          <CustomTabs tabs={tabs} />
          <div className="w-full border-t border-gray-300" />
          
          {activeLink !== 'users' && (
            <div className="mt-5 sm:mt-0 sm flex space-x-3 items-center mb-10 pt-6">
              <div className="flex-grow relative rounded-md shadow-sm">
                <input
                  type="text"
                  name="search"
                  id="search"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                  placeholder="Filter "
                />
              </div>
            </div>
          )}          
        </div>

        <div>
          {activeLink === 'employeeView' && 
            <EmployeeList searchTerm={searchTerm || ''} 
              employees={employees} />
          }
          {activeLink === 'cert' &&
            <CertificationsListCp
              certs={employeeCerts}
              searchTerm={searchTerm || ''}
              onEditCert={handleEditCertification}
              // onAddCert={handleAddCert}
              access={access}
              onFileUpload={handleCertFileUpload}
              onDeleteCert={handleDelete}
            />
          }
          {activeLink === 'fleet' &&
            <FleetCp
              fleets={fleet}
              searchTerm={searchTerm || ''}
              onEditCert={handleEditCert}
              onAddFleet={onAddFleet}
              access={access}
              employees={employees}
            />
          }
          {activeLink === 'users' &&
            <Users
              fleets={fleet}
              searchTerm={searchTerm || ''}
              onEditCert={handleEditCert}
              // onAddCert={handleAddCert}
              access={access}
              onFileUpload={handleFormSubmit}
              onDeleteCert={handleDelete}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default EmployeeListPage;
